import React from 'react'
import "../screens/HomeScreen.css"
import Nav from '../components/Nav'
import Hero from '../components/Hero'
import Services from '../components/Services'
import Work from '../components/Work'
import Form from '../components/Form'
import Projects from '../components/Projects'

function HomeScreen() {
  return (
    <div className='homeScreen'>
        <Nav/>
    <div className='homeScreenContent'>
    <Hero/>
    <Services/>
    <Projects/>
    <Work/>
    <Form/>
    </div>
    </div>
  )
}

export default HomeScreen
